<template lang="pug">
  #app
    //.season-decoration
      b-img(src="@/assets/ilustrations/spider-web.svg")
      b-img(src="@/assets/an-muertos.png")
    router-view
    vue-progress-bar
</template>

<script>

export default {
  created () {
    if (this.dashboardType === 'banorte') {
      import('@/assets/banorte/theme.scss')
    } else {
      import('@/assets/theme.scss')
    }
  },
  mounted () {
    const tag = this.$createElement
    /*
    try{
      this.$message.info({
        duration: 0,
        showClose: true,
        message: tag('p', { style: 'width: 1100px; text-align: center' }, [
          tag('p', null, 'La plataforma estará en mantenimiento entre las 1:00 AM y las 5:00 AM.'),
          tag('p', null, 'Lamentablemente, durante este tiempo no estará disponible.'),
          tag('p', null, 'Agradecemos su paciencia y comprensión.'),
          tag('a', { attrs: { href: 'https://status.nerds.ai' }, style: 'color: inherit; margin-top: 20px; text-decoration: none; cursor:pointer; background-color: #ccdcff; padding: 0px 2px; border-radius: 5px; font-size: 16px;' }, 'https://status.nerds.ai '),          
        ])
      })
    }catch(e){

    }
    */
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    window.BMessagingReady = () => {
      if (this.noSupportWidgetViews.includes(this.$route.name)) {
        this.hideWidget();
      } else {
        this.hideWidget(false);
      }
    }

    let canny = document.createElement('script')
    canny.innerHTML = '!function(w,d,i,s){function l(){if(!d.getElementById(i)){var f=d.getElementsByTagName(s)[0],e=d.createElement(s);e.type="text/javascript",e.async=!0,e.src="https://canny.io/sdk.js",f.parentNode.insertBefore(e,f)}}if("function"!=typeof w.Canny){var c=function(){c.q.push(arguments)};c.q=[],w.Canny=c,"complete"===d.readyState?l():w.attachEvent?w.attachEvent("onload",l):w.addEventListener("load",l,!1)}}(window,document,"canny-jssdk","script");';
    document.getElementsByTagName('head')[0].appendChild(canny)

    //Hotjar Tracking Code for https://socialkit.botlers.io/login
    if(process.env.VUE_APP_ENV_MODE === "production"){
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2769541,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    }

    window.addEventListener('message', event => {
      if (event.origin == 'https://widget.botlers.io') {
        if (event.data.type == 'OPEN_PAGE') {
          if (event.data.target == '_blank') {
            window.open(event.data.target, '_blank')
          } else {
            this.$router.push({ name: event.data.page })
          }
        }
      }
    })
  },
  data () {
    return {
      noSupportWidgetViews: [
        'Case',
        'Conversation',
        'Widget',
        'payment result',
        'Stripe Refresh'
      ]
    }
  },
  methods: {
    hideWidget (hide = true) {
      let styleTag = document.getElementById("button-style-overwrite")

      if (hide) {
        if (styleTag) return

        var css = `
          #botlers-messaging-button-iframe, #botlers-messaging-chat-iframe-container, #botlers-messaging-messages-preview-container {
            display: none !important;
          }
        `,
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style')
        style.id = "button-style-overwrite"

        head.appendChild(style);

        style.type = 'text/css';
        if (style.styleSheet){
          // This is required for IE8 and below.
          style.styleSheet.cssText = css
        } else {
          style.appendChild(document.createTextNode(css))
        }
      } else if (styleTag) {
        styleTag.parentNode.removeChild(styleTag)
      }
    },
  },
  watch: {
    '$route' (newValue) {
      if (newValue.name && this.noSupportWidgetViews.includes(newValue.name)) {
        this.hideWidget()
      } else {
        this.hideWidget(false)
      }
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: Cerebri;
  src: url('./assets/fonts/cerebri-sans-medium.ttf');
}

@font-face {
  font-family: "feather";
  src: url('./assets/fonts/feather.eot?t=1501834582692'); /* IE9*/
  src: url('./assets/fonts/feather.eot?t=1501834582692#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('./assets/fonts/feather.woff?t=1501834582692') format('woff'), /* chrome, firefox */
  url('./assets/fonts/feather.ttf?t=1501834582692') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/
  url('./assets/fonts/feather.svg?t=1501834582692#feather') format('svg'); /* iOS 4.1- */
}

@font-face {
  font-family: Manrope;
  src: url('./assets/fonts/Manrope/Manrope-Bold.ttf');
  src: url('./assets/fonts/Manrope/Manrope-ExtraBold.ttf');
  src: url('./assets/fonts/Manrope/Manrope-ExtraLight.ttf');
  src: url('./assets/fonts/Manrope/Manrope-Medium.ttf');
  src: url('./assets/fonts/Manrope/Manrope-Regular.ttf');
  src: url('./assets/fonts/Manrope/Manrope-SemiBold.ttf');
}

@font-face {
  font-family: 'Space Grotesk';
  src: url('./assets/fonts/SpaceGrotesk/SpaceGrotesk-Bold.ttf');
  src: url('./assets/fonts/SpaceGrotesk/SpaceGrotesk-Light.ttf');
  src: url('./assets/fonts/SpaceGrotesk/SpaceGrotesk-Medium.ttf');
  src: url('./assets/fonts/SpaceGrotesk/SpaceGrotesk-Regular.ttf');
  src: url('./assets/fonts/SpaceGrotesk/SpaceGrotesk-SemiBold.ttf');
}

html, body {
  width: 1px;
  height: 1px;
  min-width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 0;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#app {
  width: 1px;
  height: 1px;
  min-width: 100%;
  min-height: 100%;
  position:relative;
}

/*#app::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: .3;
  z-index: -1;
  background: url("assets/snowing.gif") repeat fixed center;
}*/

.widget-hidden {
  display: none !important;
}

.season-decoration {
  position: absolute;
  top: 0;
  left: 50%;
  user-select: none !important;
  pointer-events: none !important;
  z-index: 100;

  img {
    width: 50px;
    height: auto;
  }
}
</style>
